import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/motion/SmoothScroll";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import CategoriesIndex from "@/pages/CategoriesIndex";
import Category from "@/pages/Category";
import Product from "@/pages/Product";
import Coas from "@/pages/Coas";
import QualityStandards from "@/pages/QualityStandards";
import About from "@/pages/About";
import ResearchResources from "@/pages/ResearchResources";
import Article from "@/pages/Article";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Cart from "@/pages/Cart";
import SearchPage from "@/pages/SearchPage";
import PolicyPage from "@/pages/PolicyPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <SmoothScroll>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/categories" element={<CategoriesIndex />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/product/:slug" element={<Product />} />
              <Route path="/coas" element={<Coas />} />
              <Route path="/quality-standards" element={<QualityStandards />} />
              <Route path="/about" element={<About />} />
              <Route path="/research-resources" element={<ResearchResources />} />
              <Route path="/research-resources/:slug" element={<Article />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/shipping-policy" element={<PolicyPage type="shipping-policy" />} />
              <Route path="/returns-policy" element={<PolicyPage type="returns-policy" />} />
              <Route path="/privacy-policy" element={<PolicyPage type="privacy-policy" />} />
              <Route path="/terms" element={<PolicyPage type="terms" />} />
              <Route path="/accessibility" element={<PolicyPage type="accessibility" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </SmoothScroll>
        <Toaster position="bottom-right" richColors />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
